import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import * as grid from 'view/styles/grid';
import { token } from '@atlaskit/tokens';
import { ThemedLink } from '@atlassian/help-center-common-component/themed-link';

// eslint-disable-next-line rulesdir/no-styled-export
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    margin-top: ${token('space.600', '48px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const IconContainer = styled.div`
    width: ${grid.multiple(14).px};
    margin-bottom: ${token('space.200', '16px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Message = styled.div`
    ${fonts.h600};
    /* setting max-width 100% because on IE, text flows out of the container */
    max-width: 100%;
    margin: 0 0 ${token('space.100', '8px')} 0;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Description = styled.p`
    ${fonts.regular};
    /* setting max-width 100% because on IE, text flows out of the container */
    max-width: 100%;
    margin: 0 0 ${token('space.100', '8px')} 0;
    text-align: center;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Link = styled(ThemedLink)`
    text-align: center;
`;
